import { useMemo } from 'react';
import { useI18n } from '../i18n/context.js';
import { createAuthSchemas, type AuthSchemas } from './schemas.js';

/** Валидационные сообщения создаются из активной локали, а не при импорте модуля. */
export function useAuthSchemas(): AuthSchemas {
  const { t } = useI18n();
  return useMemo(() => createAuthSchemas(t.auth.validation), [t]);
}
